/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_VimeoInputs */

const en_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const fr_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const de_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const it_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const ru_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const es_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const zh_cn2_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const ja_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヴィメオ`)
};

const hi_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विमियो`)
};

const pt_pt2_new_project_media_source_vimeo = /** @type {(inputs: New_Project_Media_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

/**
* | output |
* | --- |
* | "Vimeo" |
*
* @param {New_Project_Media_Source_VimeoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_vimeo = /** @type {((inputs?: New_Project_Media_Source_VimeoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_VimeoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_vimeo(inputs)
	if (locale === "de") return de_new_project_media_source_vimeo(inputs)
	if (locale === "it") return it_new_project_media_source_vimeo(inputs)
	if (locale === "ru") return ru_new_project_media_source_vimeo(inputs)
	if (locale === "es") return es_new_project_media_source_vimeo(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_vimeo(inputs)
	if (locale === "ja") return ja_new_project_media_source_vimeo(inputs)
	if (locale === "hi") return hi_new_project_media_source_vimeo(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_vimeo(inputs)
	return en_new_project_media_source_vimeo(inputs)
});